import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      display: "flex",
      flexDirection: "row",
      paddingBottom: spacing.xxs,
      alignItems: "center",
    },
    text: {
      margin: 0,
      color: theme.chart.projection.default.text,
      flex: 1,
    },
    amount: {
      color: theme.chart.projection.default.text,
    },
  };

  return styles;
};
